import { BUBBLETAP_TEL, supportEmail } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function YouthProtectionPolicyKo() {
  const SUPPORT_EMAIL = supportEmail('ko');

  return (
    <Styled.MainWrapper>
      <h3 style={{ marginBottom: '40px' }}>주식회사 버블탭 청소년보호정책</h3>
      주식회사 버블탭(이하 "회사")은 청소년의 안전한 인터넷 사용을 돕기 위해 정보통신망 이용촉진 및 정보보호 등에 관한
      법률에서 정한 청소년 보호정책을 시행하고 있습니다.
      <p>제1조 청소년 보호를 위한 목표 및 기본 원칙</p>
      청소년이 정신적·신체적으로 유해한 환경으로부터 보호받고 건전하게 성장할 수 있도록 노력하며, 안전하게 인터넷을
      이용할 수 있는 서비스를 제공하기 위해 청소년 보호정책을 명시하고 있습니다.
      <p>제2조 청소년유해정보에 대한 청소년 보호 장치 및 관리조치</p>
      청소년이 아무런 제한장치 없이 유해정보에 노출되지 않도록 청소년 유해매체물에 대해서 연령인증장치를 마련, 적용하고
      있기에 성인 인증장치가 마련된 서비스에 대해서는 이용범위를 제한하게 하는 등 관리를 진행하고 있습니다. 이외에도
      회사는 불법적이거나 청소년에 유해한 내용 및 콘텐츠를 지속적으로 모니터링하고 관리하고 있습니다.
      <p>제3조 청소년유해정보로 인한 피해상담 및 고충처리</p>
      유해정보로 인한 피해상담 및 고충처리를 위한 전문인력을 배치하여 피해가 확산되지 않도록 하고 있습니다. 하단의
      청소년 보호 책임자의 소속 및 성명, 연락처를 참고하시어 피해상담 및 고충처리를 요청하실 수도 있습니다. 자체적으로
      처리가 곤란할 경우 관련기간을 안내해 드리고 있습니다.
      <p>제4조 유해정보로부터 청소년을 보호하기 위한 교육</p>
      회사는 청소년보호담당자 및 각 서비스 담당자들을 대상으로 청소년 보호를 위한 각종 관련 법령 및 제재기준, 유해정보
      발견 시 대처방법, 위반사항 처리에 대한 보고절차 등을 교육하고 있습니다.
      <p>제5조 청소년보호책임자 및 담당자의 지정</p>
      아래와 같이 청소년보호책임자 및 청소년보호담당자를 지정하여 청소년유해정보의 차단 관리, 청소녀유해정보로부터의
      청소년보호정책을 수립하는 등 건전한 인터넷 환경을 조성하기 위한 제반 활동을 전개합니다.
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>구분</th>
              <th>이름</th>
              <th>소속</th>
              <th>직위</th>
              <th>전화</th>
              <th>문의</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                청소년
                <br />
                보호 책임자
              </td>
              <td>박종범</td>
              <td>버블탭팀</td>
              <td>CEO</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
              <td>{SUPPORT_EMAIL}</td>
            </tr>
            <tr>
              <td>
                청소년
                <br />
                보호 책임자
              </td>
              <td>박영은</td>
              <td>버블탭팀</td>
              <td>실장</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>

              <td>{SUPPORT_EMAIL}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Styled.MainWrapper>
  );
}
